import Raven from "raven-js";
import { sentryRelease } from "nexia_mobile/version";
import Environment from "nexia_mobile/environment";
import LocalSettings from "nexia_mobile/models/local_settings";

const endpoint = "https://172be0dae8484dfe8a681f5f229e58d4@sentry.io/56039";
const config = {
  release: sentryRelease,
  shouldSendCallback: () =>
    Environment.isProductionDeployTarget() &&
    LocalSettings.isPointedToProductionHost(),
};

Raven.config(endpoint, config).install();

window.addEventListener("unhandledrejection", (event) => {
  Raven.captureException(event.reason);
});

export default config;



// WEBPACK FOOTER //
// ./src/raven_config.js